import { ChangeDetectionStrategy, Component } from '@angular/core';
import { connectState } from '@examdojo/angular/util';
import { ButtonComponent } from '@examdojo/core/button';
import { IconComponent } from '@examdojo/core/icon';
import { QuestionBankQuery } from '../../app/question-bank.query';
import { QuestionBankService } from '../../app/question-bank.service';

@Component({
  selector: 'dojo-question-bank-pagination',
  templateUrl: './question-bank-pagination.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  styles: [
    `
      .page-number-button {
        ::ng-deep ion-button.ion-button {
          &:hover::part(native) {
            &::before {
              @media screen and (min-width: 768px) {
                color: theme('colors.sky.100');
                box-shadow: 0 calc(var(--border-bottom-width) - var(--border-width)) 0;
              }
            }
          }
        }

        &.active ::ng-deep {
          .ion-button::part(native)::before {
            background: theme('colors.sky.100');
            color: theme('colors.sky.100');
            box-shadow: 0 calc(var(--border-bottom-width) - var(--border-width)) 0;
          }
        }
      }
    `,
  ],
  imports: [IconComponent, ButtonComponent],
})
export class QuestionBankPaginationComponent {
  constructor(
    private readonly questionBankQuery: QuestionBankQuery,
    private readonly questionBankService: QuestionBankService,
  ) {}

  readonly state = connectState({
    pagination: this.questionBankQuery.selectPagination(),
  });

  goToPage(page: number): void {
    this.questionBankService.changePage(page);
  }

  goToNextPage(): void {
    const pagination = this.state.pagination;
    if (pagination && !pagination.isNextDisabled) {
      this.questionBankService.changePage(pagination.page + 1);
    }
  }

  goToPreviousPage(): void {
    const pagination = this.state.pagination;
    if (pagination && !pagination.isPreviousDisabled) {
      this.questionBankService.changePage(pagination.page - 1);
    }
  }
}
